import AgoraRTC, { ClientConfig, createClient, createMicrophoneAndCameraTracks, ICameraVideoTrack, UID } from 'agora-rtc-react'
import { useEffect, useState } from 'react'
import constants from '../../config/constants.json'

export const appId = constants.AGORA_APP_ID

export interface IAgoraRTCLocalUser
{
	videoTrack: ICameraVideoTrack | null
}

const config: ClientConfig = {
	codec: 'h264',
	mode: 'live',
}

export const useClient = createClient(config)

export const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks(
    { encoderConfig: 'speech_standard' }, 
	{ encoderConfig: { height: { max: 180, min: 180 }, width: { max: 320, min: 320 }, bitrateMin: 140 }, optimizationMode: 'motion' },
)  

export enum DealerCamera {
	Face = 1000,
	Table = 1001,
	Overview = 1002,
}

export function isDealer(userAgoraUid: UID) : boolean
{
	return userAgoraUid === DealerCamera.Face || userAgoraUid === DealerCamera.Overview || userAgoraUid === DealerCamera.Table
}

export const useCameras = () =>
{
	const [cameras, setCameras] = useState<MediaDeviceInfo[]>([])
	const [isLoadingCameras, setLoadingCameras] = useState(false)

	const reloadCameras = () => {
		if (!isLoadingCameras) {
			setLoadingCameras(true)
			AgoraRTC.getCameras(true)
				.then((it) => setCameras(it))
				.finally(() => setLoadingCameras(false))
		}
	}

	useEffect(() => {
		reloadCameras()
	}, [])

	return {
		cameras,
		isLoadingCameras,
		reloadCameras
	}
}

